// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

const m0 =
  '<path d="M20 7L19.05 4.95 17 4 19.05 3.05 20 1 20.95 3.05 23 4 20.95 4.95 20 7ZM8.5 7L7.55 4.95 5.5 4 7.55 3.05 8.5 1 9.45 3.05 11.5 4 9.45 4.95 8.5 7ZM20 18.5L19.05 16.45 17 15.5 19.05 14.55 20 12.5 20.95 14.55 23 15.5 20.95 16.45 20 18.5ZM5.1 21.7L2.3 18.9Q2 18.6 2 18.18T2.3 17.46L13.45 6.3Q13.75 6 14.17 6T14.89 6.3L17.69 9.1Q17.99 9.4 17.99 9.82T17.69 10.54L6.55 21.7Q6.25 22 5.83 22T5.11 21.7ZM14.17 11.23L15.57 9.83 14.17 8.43 12.77 9.83 14.17 11.23Z"/>';

/** Magic / auto (games). */
const icon: IconData = {
  id: "magic",
  name: "Magic / auto",
  category: "games",
  styles: {
    rounded: { svg: m0 },
    sharp: { svg: m0 },
    outline: { svg: m0 },
    duotone: {
      svg: '<g opacity=".32"><path d="M20 7L19.05 4.95 17 4 19.05 3.05 20 1 20.95 3.05 23 4 20.95 4.95 20 7ZM8.5 7L7.55 4.95 5.5 4 7.55 3.05 8.5 1 9.45 3.05 11.5 4 9.45 4.95 8.5 7ZM20 18.5L19.05 16.45 17 15.5 19.05 14.55 20 12.5 20.95 14.55 23 15.5 20.95 16.45 20 18.5ZM5.1 21.7L2.3 18.9Q2 18.6 2 18.18T2.3 17.46L13.45 6.3Q13.75 6 14.17 6T14.89 6.3L17.69 9.1Q17.99 9.4 17.99 9.82T17.69 10.54L6.55 21.7Q6.25 22 5.83 22T5.11 21.7ZM14.17 11.23L15.57 9.83 14.17 8.43 12.77 9.83 14.17 11.23Z"/></g><path d="M20 7L19.05 4.95 17 4 19.05 3.05 20 1 20.95 3.05 23 4 20.95 4.95 20 7ZM8.5 7L7.55 4.95 5.5 4 7.55 3.05 8.5 1 9.45 3.05 11.5 4 9.45 4.95 8.5 7ZM20 18.5L19.05 16.45 17 15.5 19.05 14.55 20 12.5 20.95 14.55 23 15.5 20.95 16.45 20 18.5ZM5.1 21.7L2.3 18.9Q2 18.6 2 18.18T2.3 17.46L13.45 6.3Q13.75 6 14.17 6T14.89 6.3L17.69 9.1Q17.99 9.4 17.99 9.82T17.69 10.54L6.55 21.7Q6.25 22 5.83 22T5.11 21.7ZM14.17 11.23L15.57 9.83 14.17 8.43 12.77 9.83 14.17 11.23Z"/>',
    },
  },
  animation: () => import("../animations/magic.js"),
};

export default icon;
